import { USERS, setUser } from "../lib/user.js";

// Eenmalige keuze: wie gebruikt dit toestel?
export function IdentityGate({ onPick }) {
  const pick = (id) => { setUser(id); onPick(id); };
  return (
    <div style={{ position:"fixed", inset:0, zIndex:900, background:"#faf8f4",
                  display:"flex", flexDirection:"column", alignItems:"center", justifyContent:"center",
                  padding:"24px", textAlign:"center" }}>
      <div style={{ fontSize:34, marginBottom:6 }}>⛰</div>
      <h1 style={{ fontSize:22, fontWeight:700, margin:"0 0 6px" }}>Portugal Verkenner</h1>
      <p style={{ fontSize:14, color:"#777", margin:"0 0 24px" }}>Wie ben je?</p>
      <div style={{ display:"flex", flexDirection:"column", gap:12, width:"100%", maxWidth:300 }}>
        {Object.values(USERS).map(u => (
          <button key={u.id} onClick={() => pick(u.id)}
            style={{ display:"flex", alignItems:"center", gap:14, padding:"14px 18px",
                     border:"1px solid #ddd", borderRadius:14, background:"#fff", cursor:"pointer",
                     fontSize:16, fontWeight:600, color:"#333" }}>
            <span style={{ fontSize:24 }}>{u.emoji}</span>
            <span style={{ flex:1, textAlign:"left" }}>{u.name}</span>
            <span style={{ fontSize:12, color:"#999", fontWeight:500 }}>
              {u.role === "viewer" ? "alleen kijken" : "bewerken"}
            </span>
          </button>
        ))}
      </div>
      <p style={{ fontSize:11, color:"#aaa", marginTop:20, maxWidth:300 }}>
        Je kunt later wisselen via je naam bovenin. Viewer kan alles bekijken maar niets wijzigen.
      </p>
    </div>
  );
}
